// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallAdd24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.11474 5.94182C8.95579 4.81701 7.99327 3.98921 6.86398 4.00011H4.57052C3.93819 4.00089 3.33601 4.2669 2.91025 4.73331C2.48446 5.19975 2.27432 5.82368 2.33116 6.45268C2.59584 8.94595 3.44039 11.3311 4.79749 13.4259C6.02782 15.3622 7.67388 17.0082 9.61538 18.2419C11.6952 19.5907 14.0688 20.4351 16.5398 20.7036C17.1836 20.7619 17.8094 20.5503 18.2762 20.122C18.743 19.6937 19.0077 19.0885 19.0051 18.4549L19.0037 16.005C18.957 14.9455 18.1497 14.0438 17.0699 13.8915C16.3809 13.8006 15.7107 13.6336 15.0656 13.3929L14.9001 13.3379C14.1227 13.1127 13.2764 13.3233 12.6935 13.8997L12.1124 14.4793L11.9144 14.3531C10.6188 13.4962 9.5092 12.3866 8.65224 11.091L8.52515 10.892L9.10279 10.3147C9.68188 9.72912 9.89268 8.88265 9.66693 8.1039L9.47659 7.549C9.30803 7.02611 9.18677 6.48792 9.11474 5.94182ZM4.5714 5.43265H6.87802C7.2883 5.42869 7.63799 5.72944 7.69541 6.13566C7.79867 6.91883 7.99184 7.69426 8.27033 8.44058C8.38321 8.74088 8.3114 9.07758 8.08704 9.30447L7.11601 10.2755C6.888 10.5035 6.84045 10.8557 6.99983 11.1361C8.15517 13.1679 9.83749 14.8502 11.8693 16.0055C12.1496 16.1649 12.5019 16.1174 12.7299 15.8894L13.7038 14.9155C13.9278 14.694 14.2645 14.6222 14.5632 14.7344C15.3111 15.0135 16.0866 15.2067 16.8763 15.3109C17.2808 15.368 17.5831 15.7247 17.5728 16.1396L17.5726 18.4578C17.5735 18.6908 17.4774 18.9107 17.3078 19.0663C17.1382 19.2218 16.9109 19.2987 16.6817 19.278C14.4464 19.035 12.2868 18.2668 10.3894 17.0363C8.61981 15.9118 7.12425 14.4162 6.00333 12.6522C4.76518 10.7409 3.99676 8.57084 3.75694 6.3125C3.73739 6.09519 3.81373 5.86854 3.96841 5.69909C4.12309 5.52964 4.3419 5.43298 4.5714 5.43265Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M18 2C18.4142 2 18.75 2.33579 18.75 2.75V5.25H21.25C21.6642 5.25 22 5.58579 22 6C22 6.41421 21.6642 6.75 21.25 6.75H18.75V9.25C18.75 9.66421 18.4142 10 18 10C17.5858 10 17.25 9.66421 17.25 9.25V6.75H14.75C14.3358 6.75 14 6.41421 14 6C14 5.58579 14.3358 5.25 14.75 5.25H17.25V2.75C17.25 2.33579 17.5858 2 18 2Z"
				/>
			</Svg>
		);
	}
);
SvgCallAdd24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallAdd24;
